<div [ngSwitch]="data.template">
    <ng-container *ngSwitchCase="'default'">
        <span>{{ data.text }}</span>
    </ng-container>
</div>
